import axios from "axios";

// QR오더(테이블오더/직원호출/리뷰) 백엔드가 admin(9082)에서 front(9080)로 이관되면서,
// 이 요청들은 이제 front 자신의 백엔드로 나간다. front-web 의 다른 API(api/client.js)와 동일한
// REACT_APP_API_BASE_URL(기본 9080)을 사용한다.
export const QR_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:9080";

// 비회원 QR 접속이 기본이라 인증 인터셉터가 필요 없다(회원 로그인은 선택사항이며, 로그인 시
// 발급받은 토큰은 api/qrOrder.js 가 필요한 요청에만 수동으로 Authorization 헤더에 실어보낸다 -
// front-web 자신의 회원 로그인과는 별개의 QR오더 전용 로그인이라 전역 인터셉터로 묶지 않는다).
const qrOrderClient = axios.create({ baseURL: QR_BASE_URL });

export default qrOrderClient;
